import { useState } from 'react';
import { UsersListView } from './UsersListView';
import { WaitlistView } from '../../waitlist/views/WaitlistView';
import { LandingWaitlistView } from '../../landing-waitlist/views/LandingWaitlistView';

type TabId = 'app-users' | 'language-waitlist' | 'launch-waitlist';

interface Tab {
  id: TabId;
  label: string;
  description: string;
}

const TABS: Tab[] = [
  {
    id: 'app-users',
    label: 'App Users',
    description: 'Mobile app registered users',
  },
  {
    id: 'language-waitlist',
    label: 'Language Waitlist',
    description: 'Language interest waitlist entries',
  },
  {
    id: 'launch-waitlist',
    label: 'Launch Waitlist',
    description: 'Landing page waitlist entries',
  },
];

export function UsersPage() {
  const [activeTab, setActiveTab] = useState<TabId>('app-users');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">User Management</h1>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Description */}
      <p className="text-sm text-gray-600">
        {TABS.find((tab) => tab.id === activeTab)?.description}
      </p>

      {/* Tab Content */}
      <div>
        {activeTab === 'app-users' && <UsersListView hideHeader />}
        {activeTab === 'language-waitlist' && <WaitlistView />}
        {activeTab === 'launch-waitlist' && <LandingWaitlistView />}
      </div>
    </div>
  );
}
